export default __webpack_public_path__ + "static/media/Forestwalkers.7bbbb30a.jpg";